import { render, staticRenderFns } from "./orderPay1.vue?vue&type=template&id=5772612a&scoped=true"
import script from "./orderPay1.vue?vue&type=script&lang=js"
export * from "./orderPay1.vue?vue&type=script&lang=js"
import style0 from "./orderPay1.vue?vue&type=style&index=0&id=5772612a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5772612a",
  null
  
)

export default component.exports